import deals from './deals'
import schedule from './schedule'

export default {
  client: {
    namespaced: true,
    modules: {
      deals,
      schedule
    }
  }
}
